<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form
        :inline="true"
        size="small"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="vip套餐名称">
          <el-input
            placeholder="请输入vip套餐名称"
            v-model="formInline.search"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button
        size="small"
        icon="el-icon-plus"
        type="primary"
        @click="addClick"
        >添加vip套餐</el-button
      >
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table
            size="small"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column prop="name" label="vip套餐名称"></el-table-column>
            <el-table-column
              prop="price"
              label="价格"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="original_price"
              label="划线价"
              width="120"
            ></el-table-column>
            <el-table-column prop="advantages" label="优势"></el-table-column>
            <el-table-column prop="services" label="服务">
              <template slot-scope="scope">
                <el-tag
                  v-for="(service, index) in scope.row.services"
                  :key="index"
                  size="small"
                  style="margin-right:5px;"
                >
                  {{ service }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="recommend"
              label="推荐"
              :formatter="formatRecommend"
            ></el-table-column>
            <el-table-column
              prop="duration"
              label="套餐时长"
              :formatter="formatDuration"
            ></el-table-column>
            <el-table-column
              prop="sort"
              label="排序"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              width="150"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button
                  @click="editClick(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  @click="deleteClick(scope.row)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit
      :open_add="open_edit"
      :vip_package_id="vip_package_id"
      v-if="open_edit"
      @close="closeEdit"
    ></Edit>
  </div>
</template>

<script>
import PackageApi from "@/api/package.js";
import Add from "./part/add.vue";
import Edit from "./part/edit.vue";

export default {
  components: {
    Add,
    Edit
  },
  inject: ["reload"],
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,
      form: {},
      formInline: {
        search: ""
      },
      open_add: false,
      open_edit: false,
      vip_package_id: ""
    };
  },
  created() {
    this.getTableList();
  },
  methods: {
    // 格式化推荐状态
    formatRecommend(row) {
      return row.recommend === 1 ? "推荐" : "不推荐";
    },
    // 格式化套餐时长
    formatDuration(row) {
      const map = { 0: "日", 1: "月", 2: "季", 3: "年" };
      return map[row.duration] || row.duration; // 默认显示原值（防错）
    },
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    getData() {
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      PackageApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },
    addClick() {
      this.open_add = true;
    },
    editClick(row) {
      this.vip_package_id = row.vip_package_id;
      this.open_edit = true;
    },
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          PackageApi.del({ vip_package_id: row.vip_package_id }, true)
            .then(data => {
              if (data.code == 1) {
                self.$message({ message: "删除成功", type: "success" });
                this.getTableList();
              } else {
                self.$message.error("错了哦，这是一条错误消息");
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/vip_service/package/Index.vue